export const SYM_SIGNAL_STATE_PROPERTIES = Symbol('SYM_SIGNAL_STATE_PROPERTY_FLAG');
export type SignalPropertyOptions<T = unknown> = {
  get: (internalGet: () => T) => T;
  set: (internalSet: (value: T) => void, value: T) => void;
  defaultValue?: T;
};
export type SignalPropertyDefinition = {
  propertyKey: string | symbol;
  options?: SignalPropertyOptions;
  invalidate?: () => void;
};
export function SignalStateProperty(options?: SignalPropertyOptions) {
  return function (constructor: object, propertyKey: string | symbol) {
    // Append Metadata to the constructor. Can also be handled by a map outside of the class. But this way it is more encapsulated.
    if (!constructor.constructor[SYM_SIGNAL_STATE_PROPERTIES]) {
      constructor.constructor[SYM_SIGNAL_STATE_PROPERTIES] = [] as SignalPropertyDefinition[];
    }
    constructor.constructor[SYM_SIGNAL_STATE_PROPERTIES].push({ propertyKey, options });
    // Define the descriptor. Otherwise the property would only be readable on instanciation.
    Object.defineProperty(constructor, propertyKey, {
      configurable: true,
      enumerable: true,
    });
  };
}
